import { createDirectDepositOperation, getDirectDepositStatus } from '../services/device.service.js';

const CREATE_OPERATION = 'createOperation';
const UPDATE_OPERATION = 'updateOperation';
const OPERATION_FAILED = 'failedOperation';
const START_OPERATION_UPDATING = 'startOperationUpdating';
const STOP_OPERATION_UPDATING = 'stopOperationUpdating';

const SET_OPERATION = 'setOperation';
const SET_OPERATION_TIMEOUT = 'setOperationTimeout';
const SET_IS_ACTIVE_OPERATION = 'setIsActiveOperation';
const SET_OPERATION_INTERVAL = 'setOperationInterval';

const state = {
    operation: null,
    isActiveOperation: false,
    operationTimeout: null,
    operationInterval: null,
}

const getters = {
    state: state => state,
    getOperation: state => {
        return state.operation;
    },
    getIsActiveOperation: state => {
        return state.isActiveOperation;
    }
}

const actions = {
    [CREATE_OPERATION]: async ({commit, dispatch}, {phone}) => {
        const result = await createDirectDepositOperation({
            phone: phone
        });

        commit(SET_OPERATION, result);
        dispatch(START_OPERATION_UPDATING);
        return result;
    },
    [UPDATE_OPERATION]: async ({ commit, dispatch, state }, operationId = (state.operation && state.operation.id)) => {
        if (!operationId) return;

        const result = await getDirectDepositStatus(operationId);
        commit(SET_OPERATION, result);
    },
    [START_OPERATION_UPDATING]: async ({ commit, dispatch, state }, operationId = (state.operation && state.operation.id)) => {
        dispatch(STOP_OPERATION_UPDATING);
        commit(SET_IS_ACTIVE_OPERATION, true);
        dispatch(UPDATE_OPERATION, operationId);
        if (state.operation && state.operation.status === 'completed') {
            dispatch(STOP_OPERATION_UPDATING);
        }
        commit(SET_OPERATION_TIMEOUT, new Date().getTime() + 1000*60*5);
        const interval = setInterval(() => dispatch(UPDATE_OPERATION), 1000*5);
        commit(SET_OPERATION_INTERVAL, interval);

    },
    [STOP_OPERATION_UPDATING]: async ({commit, state}) => {
        commit(SET_IS_ACTIVE_OPERATION, false);
        if (!state.operationInterval) return;

        clearInterval(state.operationInterval);
        commit(SET_OPERATION_TIMEOUT, null);
        commit(SET_OPERATION_INTERVAL, null);
    },
    [OPERATION_FAILED]: async ({ commit, dispatch }) => {
        dispatch(STOP_OPERATION_UPDATING);
        commit(SET_OPERATION, {
            status: 'completed',
            result: 'error'
        });
    },
}

const mutations = {
    [SET_OPERATION] (state, operation) {
        state.operation = operation;
    },
    [SET_IS_ACTIVE_OPERATION] (state, value) {
        state.isActiveOperation = value;
    },
    [SET_OPERATION_TIMEOUT] (state, operationTimeout) {
        state.operationTimeout = operationTimeout
    },
    [SET_OPERATION_INTERVAL] (state, operationInterval) {
        state.operationInterval = operationInterval;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./skins/xkiosk/data/direct-deposit.js